import { createContext, useContext } from 'react';
import type { Tier } from 'shared/access';

export type TierValue = {
  tier: Tier; roleLabel: string;
  consultationMode: boolean; setConsultationMode: (v: boolean) => void;
  forcedConsultation: boolean; canToggle: boolean;
};

export const TierCtx = createContext<TierValue | null>(null);

export function useTier(): TierValue {
  const v = useContext(TierCtx);
  if (!v) throw new Error('useTier must be used inside <TierProvider>.');
  return v;
}
